import { render, staticRenderFns } from "./SignDetails.vue?vue&type=template&id=61373a64&scoped=true&"
import script from "./SignDetails.vue?vue&type=script&lang=js&"
export * from "./SignDetails.vue?vue&type=script&lang=js&"
import style0 from "./SignDetails.vue?vue&type=style&index=0&id=61373a64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61373a64",
  null
  
)

export default component.exports